<template>
  <div class="search-drivers container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3  v-if="driver" class="text-themecolor">{{ title }} for {{driver.name_first}} {{driver.name_last}}</h3>
        </div>
        <div class="col-md-7 align-self-center">
            <ol  v-if="driver" class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">{{ title }} for {{driver.name_first}} {{driver.name_last}}</li>
            </ol>
        </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="card" >
          <div class="card-body">
              <div class="d-flex">
                  <h4 class="card-title"><span class="lstick"></span>Edit Profile</h4>
              </div>
          </div>
          <div class="card-body">
            <div>
              <h4>
                First Name
              </h4>
              <div>
                {{ name_first }}
              </div>
            </div>
            <br>
            <div>
              <h4>
                Last Name
              </h4>
              <div>
                {{ name_last }}
              </div>
            </div>
            <br>
            <div>
              <h4>
                Email
              </h4>
              <div>
                {{ email }}
              </div>
            </div>
            <br>
            <div>
              <h4>
                Phone
              </h4>
              <input v-model="phone_number" class="form-control" placeholder="Phone Number" type="text">
            </div>
            <br>
            <div>
              <h4>
                Bio
              </h4>
              <textarea v-model="bio" class="form-control" placeholder="Bio"></textarea>
            </div>
            <br>
            <div>
              <h4>
                Address
              </h4>
              <input v-model="location_address_1" class="form-control" placeholder="Address" type="text">
            </div>
            <br>
            <button id="save-profile-button" v-on:click="updateUserInfo()" class="btn btn-info waves-effect waves-light m-t-10" >Save Profile</button>
          </div>
        </div>
        <div class="card" >
          <div class="card-body">
              <div class="d-flex">
                  <h4 class="card-title"><span class="lstick"></span>Update Bank Information</h4>
              </div>
          </div>
          <div class="card-body">
            <div>
              <div>
                <h4>
                  Routing Number
                </h4>
                <input v-model="routingNumber" class="form-control" placeholder="Routing Number" type="number">
              </div>
              <br>
              <div>
                <h4>
                  Account Number
                </h4>
                <input v-model="accountNumber" class="form-control" placeholder="Account Number" type="number">
              </div>
              <br>
              <div>
                <h4>
                  Social Security Number (Last 4)
                </h4>
                <input v-model="ssn" class="form-control" placeholder="SSN" type="number">
              </div>
              <br>
              <button id="save-bank-button" v-on:click="updateBankInfo()" class="btn btn-info waves-effect waves-light m-t-10" >Save Bank Information</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Edit Profile',
    },
    name: 'EditProfile',
    data () {
      return {
        title: 'Driver Profile',
        data: {},
        id_driver: null,
        driver: null,
        isLoading: false,
        currentPage: 1,
        totalRows: 0,
        perPage: 20,
        limit: 10,
        prev_sort: null,
        routingNumber: '',
        accountNumber: '',
        ssn: '',
        name_first: '',
        name_last: '',
        email: '',
        phone_number: '',
        bio: '',
        location_address_1: '',
      }
    },
    components: {
      Loading
    },
    methods: {
      getUserInfo: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'users/' + this.id_driver + '/')
          .then(response => {
            console.log('user info response', response.data)
            this.driver = response.data
            this.name_first = this.driver.name_first
            this.name_last = this.driver.name_last
            this.email = this.driver.email
            this.phone_number = this.driver.phone_number
            this.bio = this.driver.bio
            this.location_address_1 = this.driver.location_address_1
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      updateUserInfo: function () {
        this.isLoading = true
        this.$http
          .patch(process.env.API_BASE_URL + 'users/' + this.id_driver + '/',
            {
              "name_first": this.name_first,
              "name_last": this.name_last,
              "email": this.email,
              "phone_number": this.phone_number,
              "bio": this.bio,
              "location_address_1": this.location_address_1,
            })
          .then(response => {
            console.log('user update response', response.data)
            this.driver = response.data
          })
          .catch(error => {
            console.log('user update error', error)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      updateBankInfo() {
        console.log('updating bank: ', this.getUser(), this.getUser()['id_user'], this.accountNumber, this.routingNumber, this.ssn)
        this.isLoading = true
        if (this.accountNumber.length == 0 || this.routingNumber.length == 0 || this.ssn.length == 0) {
          this.showToastError('Please fill in all fields')
          this.isLoading = false
          return
        }
        this.$http
          .post(process.env.API_BASE_URL + 'updateBankAccount/',
            {
              "id": this.getUser()['id_user'],
              "account_number": this.accountNumber,
              "routing_number": this.routingNumber,
              "ssn": this.ssn
            })
          .then(response => {
            console.log('bank update response', response.data)
            this.showToastError('Success!')
          })
          .catch(error => {
            console.log('bank update error', error)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      titleCase: function(str) {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
          // You do not need to check if i is larger than splitStr length, as your for does that for you
          // Assign it back to the array
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(' ');
      },
    },
    mounted () {
      this.id_driver = this.getUser()['id_user']
      this.getUserInfo()
    },
    created () {
      // document.title = "Verida Support | Driver Dashboard";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    margin-top: 10px;
  }

  .result {
    margin-top: 20px;
  }
  .table td, .table th {
    vertical-align: middle;
    padding: .85rem;
  }

  .table td .btn {
    float: right;
    position: absolute;
    right: 25px;
    transform: translateY(-50%);
    padding: 3px 12px;
  }
  .table th > div {
    position: relative;
    display: inline;
  }
  .table th > div .arrow-down {
    position: absolute;
    right: -13px;
    top: 40%;
  }
  .table-hover tbody tr.transaction-details:hover {
    background-color: transparent;
  }
  .table-hover tbody tr.transaction-details tr:hover {
    background-color: transparent;
  }
  tr.transaction-details .table-striped tbody tr:nth-of-type(odd):hover {
    background-color: #e9edf2;
  }

  textarea.form-control,
  input.form-control {
    width: 100%;
  }
  @media (min-width: 768px) {
    textarea.form-control,
    input.form-control {
      width: 30%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/EditProfile.vue